import React from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import TextField from '@material-ui/core/TextField'
import ExpandablePanel from '../../components/controls/ExpandablePanel'
import { controlHasError } from '../../lib/errorHandler'
import AnimateHeight from 'react-animate-height'
import PrintText from '../../lib/PrintText'

class ZalozenieKontynuacji extends React.Component {
  render() {
    const { title, label1, label2 } = this.props
    return (
      <ExpandablePanel title={title}>
        <form autoComplete="off" className="kontynuacja">
          <FormControlLabel
            className="checkboxLabel high-caption"
            control={
              <Checkbox
                name="Kontynuacja"
                color="primary"
                defaultChecked={this.props.data.Kontynuacja}
                onChange={(e) =>
                  this.props.onSetSectionData('Kontynuacja', e.target.checked)
                }
              />
            }
            label={label1}
          />
          <FormControlLabel
            className="checkboxLabel high-caption"
            control={
              <Checkbox
                name="Zagrozenie"
                color="primary"
                defaultChecked={this.props.data.Zagrozenie}
                onChange={(e) =>
                  this.props.onSetSectionData('Zagrozenie', e.target.checked)
                }
              />
            }
            label={label2}
          />
          {!this.props.czyPodsumowanie ? (
            <AnimateHeight
              duration={250}
              height={this.props.data.Zagrozenie ? 'auto' : 0}
            >
              <TextField
                className="textArea"
                error={controlHasError(this.props.errors, 'OpisZagrozenia')}
                name="OpisZagrozenia"
                label="Opis zagrożeń"
                multiline
                variant="outlined"
                title={this.props.data.OpisZagrozenia}
                defaultValue={this.props.data.OpisZagrozenia}
                onBlur={(e) =>
                  this.props.onSetSectionData('OpisZagrozenia', e.target.value)
                }
              />
            </AnimateHeight>
          ) : (
            this.props.data.Zagrozenie && (
              <PrintText
                text={this.props.data.OpisZagrozenia}
              />
            )
          )}
        </form>
      </ExpandablePanel>
    )
  }
}

export default ZalozenieKontynuacji
